class Menu extends HTMLElement {
    constructor() {
        super();

        this.setListeners();
    }

    setListeners() {
        this.querySelector('menu-button').addEventListener('click', this.onButtonClick.bind(this));
    }

    onButtonClick(event) {
        event.preventDefault();
        this.dataset.open = this.dataset.open == 'false' ? 'true' : 'false';
    }
}

customElements.define('navigation-menu', Menu);